import { render } from "./CommunitySection.vue?vue&type=template&id=1469a7f3&scoped=true"
import script from "./CommunitySection.vue?vue&type=script&lang=js"
export * from "./CommunitySection.vue?vue&type=script&lang=js"

import "./CommunitySection.vue?vue&type=style&index=0&id=1469a7f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1469a7f3"]])

export default __exports__